/**
 * Toast wrapper for compatibility with existing code
 * Provides a unified API that works with Sonner
 */

import { toast as sonnerToast } from 'sonner'

// Wrapper para manter compatibilidade com react-toastify
export const toast = {
  // Métodos básicos compatíveis com react-toastify
  success: (message, options = {}) => {
    if (typeof message === 'string') {
      return sonnerToast.success(message, {
        ...options,
        duration: options.autoClose || 4000,
      })
    }
    // Para objetos complexos
    return sonnerToast.success(message.toString(), options)
  },

  error: (message, options = {}) => {
    if (typeof message === 'string') {
      return sonnerToast.error(message, {
        ...options,
        duration: options.autoClose || 4000,
      })
    }
    return sonnerToast.error(message.toString(), options)
  },

  info: (message, options = {}) => {
    if (typeof message === 'string') {
      return sonnerToast.info(message, {
        ...options,
        duration: options.autoClose || 4000,
      })
    }
    return sonnerToast.info(message.toString(), options)
  },

  warning: (message, options = {}) => {
    if (typeof message === 'string') {
      return sonnerToast.warning(message, {
        ...options,
        duration: options.autoClose || 4000,
      })
    }
    return sonnerToast.warning(message.toString(), options)
  },

  // Alias para compatibilidade com react-toastify (toast.warn)
  warn: (...args) => toast.warning(...args),

  loading: (message, options = {}) => {
    return sonnerToast.loading(message, {
      ...options,
      duration: options.autoClose || Infinity,
    })
  },

  // Método promise para operações assíncronas
  promise: (promise, messages) => {
    return sonnerToast.promise(promise, messages)
  },

  // Dismiss toasts
  dismiss: (toastId) => {
    if (toastId) {
      return sonnerToast.dismiss(toastId)
    }
    return sonnerToast.dismiss()
  },

  // Método customizado para compatibilidade com o sistema antigo
  custom: ({ title, description, variant = 'default', ...options }) => {
    const methodMap = {
      destructive: 'error',
      success: 'success',
      default: 'info',
    }

    const method = methodMap[variant] || 'info'

    if (description) {
      return sonnerToast[method](title, {
        description,
        ...options,
      })
    }

    return sonnerToast[method](title, options)
  },
}

// Hook para compatibilidade com useToast customizado
export function useToast() {
  return {
    toast: toast.custom,
    toasts: [], // Sonner gerencia internamente, retornamos array vazio para compatibilidade
    dismiss: toast.dismiss,
  }
}

// Export default para facilitar imports
export default toast